import Vue from 'vue'
import Component from 'vue-class-component'
import { appPaginationStore } from '@/store/modules/appPagination'

interface IPaginationMix {
    calcSkip: (pagination: Record<string, any>) => number;
    calcSkipPage: (page: number) => number;
}

@Component
export class PaginationMix extends Vue implements IPaginationMix {
    AppPageParams = appPaginationStore.PageParams
    //AppTableParams = appPaginationStore.TableParams
    constructor() {
        super();
    }

    calcSkip(pagination: Record<string, any>): number {
        console.log('pagination', pagination)
        let skip = 0;
        if (pagination && pagination.current > 0) {
            skip = (pagination.current - 1) * pagination.pageSize;
        }
        return skip
    }
    calcSkipPage(page: number): number {
        console.log('page', page)
        return (page - 1) * this.AppPageParams.pageSize;
    }

}